import gql from "graphql-tag";

export default gql`
	mutation updateLimit($limit_id: ID, $user_id: ID, $group_id: ID, $limit: Int!) {
		updateLimit(limitId: $limit_id, userId: $user_id, groupId: $group_id, limit: $limit) {
			success
		}
	}
`;
